export default "__VITE_ASSET__Bq$1CRpt__"